// 規約・ポリシーへのリンク。**URL の組み立てはここが唯一の場所**にする
// （文書ページ自身・ダッシュボードのフッター・登録モーダルの同意文の3か所から使う）。
import { t } from '@/platform/i18n';

export type LegalDocName = 'privacy' | 'terms';

/** サブパス配信（BASE_PATH）でも壊れないようベース URL を前置する。 */
export function siteUrl(path: string): string {
  const base = import.meta.env.BASE_URL || '/';
  return `${base.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
}

export function legalUrl(name: LegalDocName): string {
  return siteUrl(`${name}.html`);
}

export function escapeHtml(s: string): string {
  return s.replace(
    /[&<>"']/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c] as string,
  );
}

/** 文書名（`legal` カタログを読まずに出せるよう `portal` カタログに置いてある）。 */
export function legalLabel(name: LegalDocName): string {
  return t(name === 'privacy' ? 'portal.legal.privacy' : 'portal.legal.terms');
}

export function legalAnchor(name: LegalDocName): string {
  return `<a href="${escapeHtml(legalUrl(name))}">${escapeHtml(legalLabel(name))}</a>`;
}

/**
 * 登録モーダルの同意文（HTML）。
 * **リンクの位置を訳文側で決められるよう `{terms}` / `{privacy}` のプレースホルダにしてある**
 * （日本語と英語では語順が変わるので、コード側で前後に固定できない）。
 * エスケープしてから自前のアンカーを差し込むので、訳文に HTML が混ざっても無害。
 */
export function consentHtml(): string {
  return escapeHtml(t('portal.register.consent'))
    .replace('{terms}', legalAnchor('terms'))
    .replace('{privacy}', legalAnchor('privacy'));
}
